export default __webpack_public_path__ + "media/images/react_icons/instagram-with-frame-a2fcbf5efb7ceb229eae354408d99000.svg";